import { createStore, createEvent } from 'effector';
import { isEqual } from 'lodash';
import { signout } from '@features/common';

function createFilterBag(defaultFilters: any) {
  const changedFilterVisibility = createEvent<boolean>();
  const filtersSubmitted = createEvent<any>();

  const $isFilterOpen = createStore<boolean>(false);
  const $filters = createStore<any>(defaultFilters);
  const $isFiltersApply = $filters.map((filters) => !isEqual(filters, defaultFilters));

  $isFilterOpen.on(changedFilterVisibility, (_, visibility) => visibility).reset(signout);
  $filters.on(filtersSubmitted, (_, filters) => filters || defaultFilters).reset(signout);

  return {
    changedFilterVisibility,
    filtersSubmitted,
    $isFilterOpen,
    $filters,
    $isFiltersApply,
  };
}

export { createFilterBag };
